var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-slide-group',_vm._l((_vm.inventory),function(item){return _c('v-slide-item',{key:item.id,attrs:{"disabled":""}},[_c('gallery-item',{attrs:{"item":item}})],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }